import { FC } from 'react';
import SuperSelect from '../SuperSelect';
import SearchFormItem from './subpage/searchFormItem';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { SuperSelectProps } from '../SuperSelect/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormSuperSelectProps extends BaseSearchFormItemProps {
  /** superSelect Props */
  superSelectProps?: SuperSelectProps;
  /** 字典code */
  enumCode?: string;
}
/** 非antd的下拉 */
export const SearchFormSuperSelect: FC<SearchFormSuperSelectProps> = props => {
  const {
    superSelectProps,
    isDetail,
    enumCode,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || superSelectProps?.disabled}
      name={name}
      label={label}
      rules={rules}
      validateTrigger="onChange"
    >
      <SuperSelect
        allowClear
        showSearch
        test-id={`${testId}-${name}`}
        enumCode={enumCode}
        disabledRender={render || disabledRender}
        {...superSelectProps}
        disabled={isDetail || superSelectProps?.disabled}
        placeholder={getSelectPlaceholder(label, superSelectProps, rules)}
      />
    </SearchFormItem>
  );
};

SearchFormSuperSelect.displayName = SearchFormItemEnum.SearchFormSuperSelect;

export default SearchFormSuperSelect;
